<template>
    <div>
        <div v-if="isLoading">
            <veui-loading
                :loading="isLoading" class="loading"
                ui="strong l"
            >
                加载中
            </veui-loading>
        </div>
        <template v-else>
            <div v-if="isSettlePage" class="settle-wrap">
                <law-settle></law-settle>
            </div>
            <close-account-page
                v-else-if="isCloseAccountPage"
                @changeCloseAccountPage="changeCloseAccountPage"
            >
            </close-account-page>
            <div v-else>
                <div v-if="showFirmLawyer">
                    <div
                        class="materical"
                        :class="{'plugin-materical': $route.name !== 'FillData'}"
                    >
                        <veui-steps
                            class="steps"
                            :steps="steps"
                            :current="firmLawyerCurrent - 1"
                        />
                    </div>
                </div>
                <div v-else>
                    <div
                        v-if="userInfo && userInfo.lawyer_info && String(userInfo.lawyer_info.info_status) !== '4'"
                        class="materical"
                        :class="{'plugin-materical': $route.name !== 'FillData'}"
                    >
                        <veui-steps
                            class="steps"
                            :steps="steps"
                            :current="current - 1"
                        />
                    </div>
                </div>
                <div v-if="current === 1 && isLoadPass" class="approve">
                    <span class="approve-title">实名认证</span>
                    <span
                        class="approve-msg"
                    >认证信息将与登录帐号绑定，且不可解绑，不可修改，请务必保证登录帐号是律师本人帐号！</span>
                    <authomentice-name
                        :current.sync="current"
                        @getData="getUserInfoNew"
                        @changeCurrentIndex="changeCurrentIndex"
                    ></authomentice-name>
                </div>
                <div v-if="current === 2 && isLoadPass" class="approve">
                    <span class="approve-title">刷脸认证</span>
                    <span
                        class="approve-msg"
                    >刷脸认证通过后，不可修改，实名认证通过后自动进入第3步</span>
                    <authomentice-face
                        v-if="userInfo"
                        :user-info="userInfo"
                        :current.sync="current"
                        @getData="getUserInfoNew"
                        @changeCurrentIndex="changeCurrentIndex"
                    ></authomentice-face>
                </div>
                <div v-if="current === 3">
                    <authomentice-form
                        v-if="userInfo"
                        :is-edit="isEdit"
                        :edit-anchor="editAnchor"
                        @getData="getUserInfoNew"
                        @handleGotoAuth="handleGotoAuth"
                        @inEdit="isEdit = false"
                        @changeCloseAccountPage="changeCloseAccountPage"
                    ></authomentice-form>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/* global passport */
import {Loading} from 'veui';
import {mapState, mapActions} from 'vuex';
import authomenticeForm from './authentice-form';
import authomenticeFace from './authentice-face';
import authomenticeName from './authentice-name';
import lawSettle from './law-settle';
import mixinajax from '@/mixins/ajax';
import {passportOrigin} from '../../../../config/constant';
import StepsNew from '../../../components/steps';
import CloseAccountPage from './close-account-page.vue';

const passDomain = `${passportOrigin}/passApi/js/wrapper.js`;

export default {
    name: 'matrial',

    mixins: [mixinajax],

    components: {
        'veui-steps': StepsNew,
        'authomentice-form': authomenticeForm,
        'authomentice-face': authomenticeFace,
        'authomentice-name': authomenticeName,
        'law-settle': lawSettle,
        'veui-loading': Loading,
        CloseAccountPage
    },

    data() {
        return {
            current: 3,
            firmLawyerCurrent: -1,
            steps: [
                {label: '实名认证', desc: '未认证'},
                {label: '刷脸认证', desc: '未认证'},
                {label: '执业信息认证', desc: '未认证'}
            ],
            isLoadPass: false,
            isSettlePage: false,
            isEdit: false,
            isLoading: true,
            showFirmLawyer: false,
            isCloseAccountPage: false // 注销账户页面
        };
    },

    created() {
        this.isEdit = this.$route.query.isEdit === 'edit';
        this.editAnchor = this.$route.query.editAnchor;
    },

    mounted() {
        this.$nextTick(function () {
            // 加载passport
            let script = document.createElement('script');
            script.src = passDomain;
            document.body.appendChild(script);

            script.onload = () => {
                this.isLoadPass = true;
            };
        });
        this.$wywLog.addKey({
            fr: this.$route.query.from || ''
        });
        // 页面PV打点
        this.$wywLog.send({
            serverId: 16233,
            area: 'pv',
            action: 'pv'
        });
        this.getUserInfoNew();
    },

    computed: {
        ...mapState({
            bjhInfo: state => state.lawStore.bjhInfo,
            userInfo: state => state.lawStore.userInfoNew || {}
        })
    },

    watch: {
        userInfo: {
            handler(val) {
                if (val && Object.keys(val).length) {
                    const {pass_info, lawyer_info, user_role} = val || {};
                    this.isLoading = false;
                    if (lawyer_info && lawyer_info.business_lawyer_id) {
                        let steps = this.steps;
                        if (+pass_info.pass_status >= 1) {
                            steps[0] = {
                                label: '实名认证',
                                desc: '已认证',
                                status: 'success'
                            };
                        }
                        if (+pass_info.pass_status === 2) {
                            steps[1] = {
                                label: '刷脸认证',
                                desc: '已认证',
                                status: 'success'
                            };
                        }
                        const {
                            name,
                            personal_intro,
                            personal_avatar,
                            identity_national_image,
                            identity_head_image,
                            lawyer_position,
                            lawyer_position_image,
                            register_image
                        } = this.userInfo?.lawyer_info || {};
                        let text = '';
                        if (!name) {
                            text += '姓名';
                        }
                        if (!personal_intro) {
                            text += (text ? '、个人简介' : '个人简介');
                        }
                        if (!personal_avatar) {
                            text += (text ? '、执业照片' : '执业照片');
                        }
                        if (!identity_head_image || !identity_national_image) {
                            text += (text ? '、身份证照片' : '身份证照片');
                        }
                        if (lawyer_position && !lawyer_position_image) {
                            text += (text ? '、职务证明' : '职务证明');
                        }
                        if (!register_image) {
                            text += (text ? '、执业证' : '执业证');
                        }
                        this.showFirmLawyer = !(pass_info.pass_status === 2 && !text)
                            || String(lawyer_info?.info_status) === '6'
                            || String(lawyer_info?.info_status) === '2';
                        // 代表资料状态 0 = 编辑中 2 = 审核中 4 = 执业审核成功 6 = 执业审核失败
                        if (String(lawyer_info?.info_status) === '6') {
                            steps[2] = {
                                label: '执业信息认证',
                                desc: '认证失败',
                                status: 'error'
                            };
                        }
                        if (String(lawyer_info?.info_status) === '2') {
                            this.firmLawyerCurrent = 3;
                            steps[2] = {
                                label: '执业信息认证',
                                desc: '审核中'
                            };
                        }
                        if (String(lawyer_info?.info_status) === '4') {
                            steps[2] = {
                                label: '执业信息认证',
                                desc: text ? '已认证，待完善' : '已认证',
                                status: 'success'
                            };
                        }
                        this.steps = [...steps];
                        return;
                    }
                    // 未完成任何认证的新用户，展示律师入驻页面
                    if (user_role === -1 && window.location.href.includes('/filldata')) {
                        this.isSettlePage = true;
                    }
                    // verify_status 0 1 2 分别代表无认证、实名认证、活体认证
                    this.current = pass_info.pass_status + 1;
                    if (String(pass_info.pass_status) === '1') {
                        this.steps[0].desc = '已认证';
                    }
                    if (String(pass_info.pass_status) === '2') {
                        this.steps[0].desc = '已认证';
                        this.steps[1].desc = '已认证';
                    }
                    if (String(lawyer_info?.info_status) === '4') {
                        this.steps[0].desc = '已认证';
                        this.steps[1].desc = '已认证';
                        this.steps[2].desc = '已认证';
                    }
                    // audit_status 快照 只要审核通过
                    if (String(lawyer_info?.audit_status) === '4') {
                        this.steps[2].desc = '已认证';
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        ...mapActions({
            getUserInfoNew: 'lawStore/getUserInfoNew'
        }),

        changeCurrentIndex(current) {
            this.current = current;
            this.firmLawyerCurrent = current === 3 ? -1 : current;
        },

        handleGotoAuth(current) {
            this.current = current;
            this.firmLawyerCurrent = current;
        },

        // 进入/退出注销页
        changeCloseAccountPage(isEnter) {
            this.isCloseAccountPage = isEnter;
        }
    }
};
</script>

<style lang="less" scoped>
.settle-wrap {
    width: 1200px;
    padding: 90px 0 20px;
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
}

.materical {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 24px;

    .steps {
        width: 570px;
        margin: 0 auto;
    }
}

.plugin-materical {
    padding: 24px 0;
}

.approve {
    background: #fff;
    margin-top: 24px;
    padding: 24px 24px 48px;
    line-height: 28px;

    .approve-title {
        font-size: 20px;
        color: #282c33;
        font-weight: 800;
    }

    .approve-msg {
        margin-left: 12px;

        #IDCertify {
            height: 400px;
        }
    }
}

.loading {
    height: 400px;
    width: 1200px;
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep {
    .veui-steps-step-next-current .veui-steps-step-label::after {
        border-color: #05f;
    }

    .veui-steps-step-next-incomplete .veui-steps-step-label::after {
        border-color: #d5dbe7;
    }

    .veui-steps[ui~="m"] .veui-steps-step-index {
        width: 32px;
        height: 32px;
    }

    .veui-steps-step-completed .veui-steps-step-index {
        background: #fff;
        border: 1px solid #05f;
        box-sizing: border-box;

        .veui-icon {
            color: #000;
        }
    }

    .veui-steps-step-current .veui-steps-step-index {
        background: #05f;
    }
}
</style>
